import React, { useEffect, useState, useMemo } from 'react';
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';
import FormStateToRedux from '../../RFF/FormStateToRedux';
import { ModalTitle } from '../../../global/Styles/titles';
import { ButtonTable } from '../../../global/Styles/buttons';
import { inputTextAreaTrue, inputTextAreaFalse } from '../../../global/Styles/inputs';
import TableManifiesto from './TableManifiesto';
import { TableVehiculos } from './ModalSeguimiento/TableVehiculos';
import { PanelVehiculoTarifa } from './ModalSeguimiento/PanelVehiculoTarifa';
import { store } from '../../../../store';
import { CheckPermission } from '../../../../utils/security';
import { setSelTipoVehiculo, setSelTipoVehiculoInit } from '../../../../actions';

const ModalProducido = (props) => {
  const { setIsModalProducidoVisible } = props;
  const { producidoModalConfig } = props.data;
  const { saveProducido } = props.endPoint;
  const solicitud = props.Solicitud.selSolicitud || {};
  const readOnly = producidoModalConfig?.readOnly;

  // Permisos: solo Administrador o rol/permiso 'Producido' puede guardar
  const canSave = CheckPermission('Administrador') || CheckPermission('Producido');

  const vehiculos = useMemo(() => solicitud.solicitud_vehiculo_tipo || [], [solicitud.solicitud_vehiculo_tipo]);
  const [selSolicitudVehiculoTipo, setSelSolicitudVehiculoTipo] = useState(null);

  useEffect(() => {
    if (vehiculos.length === 0) {
      setSelSolicitudVehiculoTipo(null);
      store.dispatch(setSelTipoVehiculoInit());
      return;
    }

    const defaultVehiculo = vehiculos[0];
    setSelSolicitudVehiculoTipo(defaultVehiculo);
    store.dispatch(setSelTipoVehiculo(defaultVehiculo));
  }, [solicitud.SOLICITUD_ID, vehiculos.length, vehiculos]);

  const handleVehiculoSelect = (vehiculo) => {
    setSelSolicitudVehiculoTipo(vehiculo);
    store.dispatch(setSelTipoVehiculo(vehiculo));
  };

  const validate = (values) => {
    const errors = {};

    if (!readOnly && !values.PR_NOTA) {
      errors.PR_NOTA = 'Requerido';
    }

    return errors;
  };

  const handleSubmit = (values) => {
    if (readOnly) {
      setIsModalProducidoVisible(false);
      return;
    }

    saveProducido({
      solicitudId: solicitud.SOLICITUD_ID,
      nota: values.PR_NOTA,
    });
  };

  return (
    <div className="min-w-screen animated fadeIn faster fixed inset-0 left-0 top-0 z-50 flex h-screen items-center justify-center overflow-y-scroll bg-cover bg-center bg-no-repeat">
      <div className="fixed inset-0 z-0 bg-black opacity-50"></div>
      <Form
        onSubmit={handleSubmit}
        initialValues={{
          PR_NOTA: solicitud.PR_NOTA || '',
        }}
        validate={validate}
        subscription={{ submitting: true, pristine: true, valid: true }}>
        {({ handleSubmit: submit, submitting, pristine, valid }) => (
          <form
            onSubmit={submit}
            className="relative mx-auto my-auto w-full max-w-5xl rounded-xl bg-white p-5 shadow-lg">
            <ModalTitle>Nota de Producido</ModalTitle>
            <FormStateToRedux form="frmNotaProducido" />
            <div className="mt-4 space-y-6 text-left">
              {/* <p className="text-sm text-gray-700">
                Servicio: <strong>{solicitud.SOLICITUD_CONSECUTIVO_INT || 'N/A'}</strong>
              </p> */}
              {solicitud.PR_FECHA && (
                <p className="text-sm text-gray-700">
                  Fecha de registro: <strong>{solicitud.PR_FECHA}</strong>
                </p>
              )}
              <div className="space-y-4">
                <div>
                  {/* <h3 className="text-sm font-semibold uppercase text-gray-600">Resumen del servicio</h3> */}
                  <div className="mt-2 overflow-x-auto">
                    <TableManifiesto />
                  </div>
                </div>
                {vehiculos.length > 0 && (
                  <div className="space-y-3">
                    <h3 className="text-sm font-semibold uppercase text-gray-600">Vehículos del servicio</h3>
                    <div className="overflow-x-auto">
                      <TableVehiculos
                        data={{
                          solicitudVehiculoTipos: vehiculos,
                          selSolicitudVehiculoTipo: selSolicitudVehiculoTipo || {},
                        }}
                        actions={{
                          handleVehiculoSelect,
                        }}
                      />
                    </div>
                  </div>
                )}
                {selSolicitudVehiculoTipo && (
                  <div className="space-y-3">
                    <h3 className="text-sm font-semibold uppercase text-gray-600">Detalle facturado</h3>
                    <div className="overflow-x-auto">
                      <PanelVehiculoTarifa
                        handleAddTarifa={() => {}}
                        handleChangeTarifaUnidad={() => {}}
                        data={{
                          selSolicitudVehiculoTipo,
                          selSolicitud: solicitud,
                          tarifaUnidadOptions: [],
                        }}
                        isReadOnly
                      />
                    </div>
                  </div>
                )}
              </div>
              <Field name="PR_NOTA">
                {({ input, meta }) => {
                  const hasError = !readOnly && meta.error && meta.touched;

                  return (
                    <div>
                      <label
                        className="mb-1 block text-sm text-gray-800"
                        htmlFor="producido-nota">
                        Nota del producido
                      </label>
                      <textarea
                        {...input}
                        id="producido-nota"
                        rows="6"
                        disabled={readOnly}
                        className={`${hasError ? inputTextAreaFalse : inputTextAreaTrue} ${readOnly ? 'cursor-not-allowed opacity-80' : ''}`}
                        placeholder="Describe el producido del servicio"
                      />
                      {hasError && <span className="text-xs text-red-500">{meta.error}</span>}
                    </div>
                  );
                }}
              </Field>
              {readOnly && !solicitud.PR_NOTA && <p className="text-sm italic text-gray-500">No se registró nota para este producido.</p>}
            </div>
            <div className="mt-6 flex justify-end space-x-3">
              {!readOnly && <>{!canSave && <p className="ml-2 self-center text-sm text-red-500">No tienes permisos para guardar.</p>}</>}

              <ButtonTable
                type="button"
                onClick={() => setIsModalProducidoVisible(false)}>
                Cerrar
              </ButtonTable>
              {!readOnly && (
                <ButtonTable
                  type="submit"
                  disabled={submitting || pristine || !valid || !canSave}>
                  Guardar
                </ButtonTable>
              )}
            </div>
          </form>
        )}
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  Solicitud: state.Solicitud,
});

export default connect(mapStateToProps)(ModalProducido);
